import { cn, momentZoneInfo, momentZoneTitle, zoneInfo, zoneTitle } from '@/shared/lib'

interface ZoneTagProps {
  // Какая зона подписана. Обязательный: продукт живёт в двух зонах сразу, и
  // молчаливый дефолт здесь — это подпись, которая врёт про соседнее значение.
  //   'org'    — зона организации: сутки, период, срок и всё, что из срока
  //              выведено. Одна на всех, и с часами смотрящего не совпадает.
  //   'device' — зона устройства смотрящего: моменты («создано», «начато»).
  kind: 'org' | 'device'
  // Что именно показано в этой зоне: «срок», «сроки», «отправка». С префиксом
  // тег встаёт заголовком колонки/секции («срок · Москва»), без него — коротким
  // тегом рядом с одиночным значением.
  prefix?: string
  className?: string
}

// Короткий тег зоны у значения времени. Бейдж в шапке отвечает «в какой зоне
// живут сутки и сроки», но на экране этого мало: человек сверяет момент с
// календарём и телефоном прямо здесь, и зона обязана стоять рядом со значением,
// а не в другом углу экрана.
//
// Списки и колонки подписываются один раз — в заголовке (`prefix`); повтор тега
// в каждой строке превращает интерфейс в частокол и перестаёт читаться.
export function ZoneTag({ kind, prefix, className }: ZoneTagProps) {
  const zone = kind === 'org' ? zoneInfo() : momentZoneInfo()
  const title = kind === 'org' ? zoneTitle() : momentZoneTitle()
  return (
    <span
      title={title}
      className={cn(
        'inline-flex shrink-0 items-center font-mono text-[11px] whitespace-nowrap text-text-tertiary',
        className,
      )}
    >
      {prefix ? `${prefix} · ${zone.short}` : zone.short}
    </span>
  )
}
